import {
  GetApplicationForDetailsResponse
} from 'it/primatoo/openapi/api/org/schemas/application/getapplicationfordetailsresponse/GetApplicationForDetailsResponse';

export class WarningUtils {

  static showWarningFromApplicationDetails(application: GetApplicationForDetailsResponse): boolean {
    return application && WarningUtils.showWarningCondition(
      application?.confidentialityViolationImplValue,    //R
      application?.integrityCompromiseImplValue,         //I
      application?.availabilityLossImplValue);           //D
  }

  private static showWarningCondition(ridR: number, ridI: number, ridD: number, unsupported = false): boolean {
    return !unsupported &&
      (ridR === null || ridR === undefined)
      &&
      (ridI === null || ridI === undefined)
      &&
      (ridD === null || ridD === undefined);
  }
}

